// extracted by mini-css-extract-plugin
export default {"faqsWrapper":"Faqs_faqsWrapper__NanPG","faqsListWrapper":"Faqs_faqsListWrapper__Jz5Aj"};